import { CodeOutputBlock } from '@/ui';
import { TextField } from '@/ui/primitives/TextField';

type ProjectWebhookSnippetSectionProps = {
  tagsInput: string;
  onTagsInputChange: (value: string) => void;
  snippet: string;
  onCopySnippet: () => void;
  disabled: boolean;
};

export const ProjectWebhookSnippetSection = ({
  tagsInput,
  onTagsInputChange,
  snippet,
  onCopySnippet,
  disabled,
}: ProjectWebhookSnippetSectionProps): JSX.Element => {
  return (
    <>
      <TextField
        label="Webhook Tags (Comma-Separated)"
        value={tagsInput}
        placeholder="smoke, nightly"
        helperText="Tags are attached to the webhook key and inferred on incoming webhook events."
        disabled={disabled}
        onChange={(event) => {
          onTagsInputChange(event.target.value);
        }}
      />
      <CodeOutputBlock
        value={snippet}
        onCopy={onCopySnippet}
        copyAriaLabel="Copy webhook snippet"
        reserveCopySpace={false}
      />
    </>
  );
};
